import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PolicyService } from '@amfam/policy/data-access';
import { LoadingSpinnerService } from '@amfam/ui-kit';

/*
This component is not used yet but the html matches what a POI card should look like and this
component could be easily wired up if needed
*/
@Component({
  selector: 'app-proof-of-insurance-card',
  templateUrl: './proof-of-insurance.component.html',
  standalone: false
})
export class ProofOfInsuranceComponent implements OnInit, OnDestroy {
  @Input()
  policy: any;

  vehicle: any;
  private driver: any;

  @Input()
  policyType: string;

  constructor(
    private policyService: PolicyService,
    private route: ActivatedRoute,
    public spinner: LoadingSpinnerService
  ) {}

  ngOnInit() {
    // TODO - get agent information
    // TODO - convert state abbrev to name
    this.driver = this.policy.policyRoles[0]; // Always pick primary?
    this.vehicle = this.policy.vehicles[0]; // Always pick first vehicle? Can there by multiple?
  }

  ngOnDestroy() {}
}
